import { render } from "./ContactCard.vue?vue&type=template&id=f362432e&scoped=true&ts=true"
import script from "./ContactCard.vue?vue&type=script&lang=ts"
export * from "./ContactCard.vue?vue&type=script&lang=ts"

import "./ContactCard.vue?vue&type=style&index=0&id=f362432e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f362432e"]])

export default __exports__